export default {
  v100: {
    sizeValue: 'v100',
    md: {
      span: 24,
    },
    sm: {
      span: 24,
    },
    xs: {
      span: 24,
    },
  },
  o5v90: {
    sizeValue: 'o5v90',
    md: {
      span: 20,
      offset: 2,
    },
    sm: {
      span: 22,
      offset: 1,
    },
    xs: {
      span: 22,
      offset: 1,
    },
  },
  o10v80: {
    sizeValue: 'o10v80',
    md: {
      span: 18,
      offset: 3,
    },
    sm: {
      span: 24,
    },
    xs: {
      span: 24,
    },
  },
  o15v70: {
    sizeValue: 'o15v70',
    md: {
      span: 16,
      offset: 4,
    },
    sm: {
      span: 24,
    },
    xs: {
      span: 24,
    },
  },
  o20v60: {
    sizeValue: 'o20v60',
    md: {
      span: 14,
      offset: 5,
    },
    sm: {
      span: 24,
    },
    xs: {
      span: 24,
    },
  },
  o25v50: {
    sizeValue: 'o25v50',
    md: {
      span: 12,
      offset: 6,
    },
    sm: {
      span: 24,
    },
    xs: {
      span: 24,
    },
  },
  layoutBreakpoint(mq) {
    return {
      isMobile: mq === 'xs' || mq === 'sm' || mq === 'md',
      isTablet: mq === 'lg',
      isDesktop: mq === 'xl',
    };
  },
  isMobileLayout(mq) {
    return mq === 'xs' || mq === 'sm' || mq === 'md';
  },
};
